import { render, staticRenderFns } from "./modelCreateCopy.vue?vue&type=template&id=011b4921&"
import script from "./modelCreateCopy.vue?vue&type=script&lang=js&"
export * from "./modelCreateCopy.vue?vue&type=script&lang=js&"
import style0 from "./modelCreateCopy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "modelCreateCopy.vue"
export default component.exports